import React, { memo } from "react";
import type { Annotation } from "./hook/useAnnotations";
import TooltipV2 from "@ui/TooltipV2";
import { colors } from "@ui/Theme";
import { getFaultStatusText, getFaultStatusTextIcon } from "../../../../../../../Fault";
import { BookmarkLine, CheckboxMultipleLine } from "@ui/IconV2/react";
import t from "../../../../../../../../../i18n";

export const DiagramAnnotationFaultStatus = memo(
  ({ annotationValues }: { annotationValues: Annotation["values"] }) => {
    const faultStatus =
      annotationValues.find(e => e.column === "faultStatus")?.value?.toString() ?? null;
    const hasMultipleFaultStatuses = annotationValues.some(value => value.hasMultipleFaultStatuses);

    const explaination = hasMultipleFaultStatuses
      ? t("flags_legend.fault_flag.multiple_statuses")
      : faultStatus === "NON_MODELLED"
        ? t("project.dashboard.fault.non_modelled")
        : faultStatus
          ? getFaultStatusText(faultStatus)
          : null;

    return (
      <TooltipV2 overlay={explaination}>
        <span>
          {!hasMultipleFaultStatuses && faultStatus === "NON_MODELLED" && (
            <BookmarkLine size="s" color={colors.carbon800} />
          )}
          {!hasMultipleFaultStatuses &&
            faultStatus &&
            faultStatus !== "NON_MODELLED" &&
            getFaultStatusTextIcon(faultStatus)}
          {hasMultipleFaultStatuses && <CheckboxMultipleLine color={colors.carbon800} size="s" />}
        </span>
      </TooltipV2>
    );
  },
);
